import dayjs from "dayjs"
import "dayjs/locale/fr"
import LocalizedFormat from "dayjs/plugin/localizedFormat"
import i18n, { LanguageDetectorModule } from "i18next"
import LanguageDetector from "i18next-browser-languagedetector"
import _ from "lodash"
import { initReactI18next } from "react-i18next"

import commonAr from "~/assets/locales/ar/common.json"
import productSheetsAr from "~/assets/locales/ar/productSheets.json"
import commonBe from "~/assets/locales/be/common.json"
import productSheetsBe from "~/assets/locales/be/productSheets.json"
import commonDe from "~/assets/locales/de/common.json"
import productSheetsDe from "~/assets/locales/de/productSheets.json"
import accountEn from "~/assets/locales/en/account.json"
import adminEn from "~/assets/locales/en/admin.json"
import certificatesEn from "~/assets/locales/en/certificates.json"
import commonEn from "~/assets/locales/en/common.json"
import communicationStudioEn from "~/assets/locales/en/communicationStudio.json"
import dataTransferEn from "~/assets/locales/en/dataTransfer.json"
import faqEn from "~/assets/locales/en/faq.json"
import homeEn from "~/assets/locales/en/home.json"
import invoicesEn from "~/assets/locales/en/invoices.json"
import libraryEn from "~/assets/locales/en/library.json"
import organizationSettingsEn from "~/assets/locales/en/organizationSettings.json"
import productSheetsEn from "~/assets/locales/en/productSheets.json"
import productsEn from "~/assets/locales/en/products.json"
import publicEn from "~/assets/locales/en/public.json"
import regulationsEn from "~/assets/locales/en/regulations.json"
import supplierEn from "~/assets/locales/en/supplier.json"
import suppliersEn from "~/assets/locales/en/suppliers.json"
import traceabilityEn from "~/assets/locales/en/traceability.json"
import commonEs from "~/assets/locales/es/common.json"
import faqEs from "~/assets/locales/es/faq.json"
import productSheetsEs from "~/assets/locales/es/productSheets.json"
import supplierEs from "~/assets/locales/es/supplier.json"
import suppliersEs from "~/assets/locales/es/suppliers.json"
import traceabilityEs from "~/assets/locales/es/traceability.json"
import accountFr from "~/assets/locales/fr/account.json"
import adminFr from "~/assets/locales/fr/admin.json"
import certificatesFr from "~/assets/locales/fr/certificates.json"
import commonFr from "~/assets/locales/fr/common.json"
import communicationStudioFr from "~/assets/locales/fr/communicationStudio.json"
import dataTransferFr from "~/assets/locales/fr/dataTransfer.json"
import faqFr from "~/assets/locales/fr/faq.json"
import homeFr from "~/assets/locales/fr/home.json"
import invoicesFr from "~/assets/locales/fr/invoices.json"
import libraryFr from "~/assets/locales/fr/library.json"
import organizationSettingsFr from "~/assets/locales/fr/organizationSettings.json"
import productSheetsFr from "~/assets/locales/fr/productSheets.json"
import productsFr from "~/assets/locales/fr/products.json"
import publicFr from "~/assets/locales/fr/public.json"
import regulationsFr from "~/assets/locales/fr/regulations.json"
import supplierFr from "~/assets/locales/fr/supplier.json"
import suppliersFr from "~/assets/locales/fr/suppliers.json"
import traceabilityFr from "~/assets/locales/fr/traceability.json"
import commonIt from "~/assets/locales/it/common.json"
import faqIt from "~/assets/locales/it/faq.json"
import productSheetsIt from "~/assets/locales/it/productSheets.json"
import supplierIt from "~/assets/locales/it/supplier.json"
import suppliersIt from "~/assets/locales/it/suppliers.json"
import traceabilityIt from "~/assets/locales/it/traceability.json"
import commonJa from "~/assets/locales/ja/common.json"
import productSheetsJa from "~/assets/locales/ja/productSheets.json"
import commonKo from "~/assets/locales/ko/common.json"
import productSheetsKo from "~/assets/locales/ko/productSheets.json"
import commonLt from "~/assets/locales/lt/common.json"
import productSheetsLt from "~/assets/locales/lt/productSheets.json"
import commonNl from "~/assets/locales/nl/common.json"
import productSheetsNl from "~/assets/locales/nl/productSheets.json"
import commonPt from "~/assets/locales/pt/common.json"
import faqPt from "~/assets/locales/pt/faq.json"
import productsSheptsPt from "~/assets/locales/pt/productSheets.json"
import supplierPt from "~/assets/locales/pt/supplier.json"
import suppliersPt from "~/assets/locales/pt/suppliers.json"
import traceabilityPt from "~/assets/locales/pt/traceability.json"
import commonRo from "~/assets/locales/ro/common.json"
import productSheetsRo from "~/assets/locales/ro/productSheets.json"
import commonTr from "~/assets/locales/tr/common.json"
import faqTr from "~/assets/locales/tr/faq.json"
import productSheetsTr from "~/assets/locales/tr/productSheets.json"
import supplierTr from "~/assets/locales/tr/supplier.json"
import suppliersTr from "~/assets/locales/tr/suppliers.json"
import traceabilityTr from "~/assets/locales/tr/traceability.json"
import commonZh from "~/assets/locales/zh/common.json"
import faqZh from "~/assets/locales/zh/faq.json"
import productsSheetsZh from "~/assets/locales/zh/productSheets.json"
import supplierZh from "~/assets/locales/zh/supplier.json"
import suppliersZh from "~/assets/locales/zh/suppliers.json"
import traceabilityZh from "~/assets/locales/zh/traceability.json"

export const DEFAULT_NAMESPACE = "common" as const

export const SUPPORTED_LOCALES = [
  "en",
  "fr",
  "zh",
  "pt",
  "it",
  "es",
  "tr",
  "ar",
  "be",
  "ro",
  "lt",
  "ja",
  "ko",
  "nl",
  "de",
] as const

export type Locale = (typeof SUPPORTED_LOCALES)[number]

export const SUPPLIER_LOCALES = [
  "en",
  "fr",
  "zh",
  "pt",
  "it",
  "es",
  "tr",
] as const

export const BRAND_LOCALES = ["en", "fr"] as const

const userLanguageDetector: LanguageDetectorModule = {
  type: "languageDetector",
  detect: () => {
    if (typeof localStorage === "undefined") return undefined
    const lang = localStorage.getItem("i18nextLng")
    if (lang) return lang
  },
  init: _.noop,
  cacheUserLanguage: (lng: string) => {
    if (typeof localStorage === "undefined") return undefined
    localStorage.setItem("i18nextLng", lng)
  },
}

export const resources = {
  en: {
    common: commonEn,
    account: accountEn,
    library: libraryEn,
    organizationSettings: organizationSettingsEn,
    communicationStudio: communicationStudioEn,
    products: productsEn,
    suppliers: suppliersEn,
    certificates: certificatesEn,
    traceability: traceabilityEn,
    dataTransfer: dataTransferEn,
    invoices: invoicesEn,
    admin: adminEn,
    home: homeEn,
    faq: faqEn,
    supplier: supplierEn,
    public: publicEn,
    regulations: regulationsEn,
    productSheets: productSheetsEn,
  },
  fr: {
    common: commonFr,
    account: accountFr,
    library: libraryFr,
    organizationSettings: organizationSettingsFr,
    communicationStudio: communicationStudioFr,
    products: productsFr,
    suppliers: suppliersFr,
    certificates: certificatesFr,
    traceability: traceabilityFr,
    dataTransfer: dataTransferFr,
    invoices: invoicesFr,
    admin: adminFr,
    home: homeFr,
    faq: faqFr,
    supplier: supplierFr,
    public: publicFr,
    regulations: regulationsFr,
    productSheets: productSheetsFr,
  },
  zh: {
    faq: faqZh,
    common: commonZh,
    supplier: supplierZh,
    traceability: traceabilityZh,
    suppliers: suppliersZh,
    productSheets: productsSheetsZh,
  },
  pt: {
    faq: faqPt,
    common: commonPt,
    supplier: supplierPt,
    traceability: traceabilityPt,
    suppliers: suppliersPt,
    productSheets: productsSheptsPt,
  },
  it: {
    faq: faqIt,
    common: commonIt,
    supplier: supplierIt,
    traceability: traceabilityIt,
    suppliers: suppliersIt,
    productSheets: productSheetsIt,
  },
  es: {
    faq: faqEs,
    common: commonEs,
    supplier: supplierEs,
    traceability: traceabilityEs,
    suppliers: suppliersEs,
    productSheets: productSheetsEs,
  },
  tr: {
    faq: faqTr,
    common: commonTr,
    supplier: supplierTr,
    traceability: traceabilityTr,
    suppliers: suppliersTr,
    productSheets: productSheetsTr,
  },
  ar: {
    productSheets: productSheetsAr,
    common: commonAr,
  },
  be: {
    productSheets: productSheetsBe,
    common: commonBe,
  },
  ja: {
    productSheets: productSheetsJa,
    common: commonJa,
  },
  ko: {
    productSheets: productSheetsKo,
    common: commonKo,
  },
  lt: {
    productSheets: productSheetsLt,
    common: commonLt,
  },
  ro: {
    productSheets: productSheetsRo,
    common: commonRo,
  },
  nl: {
    productSheets: productSheetsNl,
    common: commonNl,
  },
  de: {
    productSheets: productSheetsDe,
    common: commonDe,
  },
}

dayjs.extend(LocalizedFormat)

i18n.on("initialized", (initOptions) => {
  dayjs.locale(initOptions.lng)
})

i18n.on("languageChanged", () => {
  dayjs.locale(i18n.language)
})

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .use(LanguageDetector)
  .use(userLanguageDetector)
  .init({
    ns: Object.keys(resources.en),
    defaultNS: DEFAULT_NAMESPACE,
    resources,
    fallbackLng: "en",
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  })

export { i18n }
